import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse } from '@libs/graphql';

type AccessTokenPayload = {
  accessToken: string;
};
export type RefreshTokenRes = {
  refreshToken: DefaultApiResponse<AccessTokenPayload>;
};

export const refreshTokenMutation: TypedDocumentNode<RefreshTokenRes> = gql`
  mutation RefreshToken {
    refreshToken {
      accessToken
    }
  }
`;
